var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.classNames.modalVideoIframeWrap,style:({ 'padding-bottom': _vm.paddingBottom })},[_c('iframe',{attrs:{"width":"460","height":"230","src":_vm.fullVideoUrl,"frameBorder":"0","allowFullScreen":_vm.allowFullScreen,"tabIndex":"-1"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }